import React, {Component} from "react";
import { connect } from 'react-redux';
import Select from 'react-select';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import {updateCompanyData} from '../../actions/companyActions'
import CreateCompanyMessage from "../Account/CreateCompanyMessage";

class CompanyData extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formEdit: false,
        }
    }

    onEdit(type = 'edit') {
        const form = this.refs.form;

        this.setState({
            formEdit: !this.state.formEdit
        }, () => {
            form.querySelectorAll(".value:not(.field-mail)").forEach(item => 
                this.state.formEdit ? item.removeAttribute("disabled") : item.setAttribute("disabled", "disabled")
            );

            if(!this.state.formEdit && type === 'edit'){
                this.props.handleCompany(this.getOldData(), false)
            }
        });
    }

    getOldData() {
        const {company:{companies}, selectedCompany} = this.props;
        
        let oldData = companies.data.results.filter(item =>
            item.id === selectedCompany.id
        );

        return oldData.length ? {value: oldData[0].id} : null;
    }

    onSubmit(e){
        e.preventDefault()
        const {selectedCompany, updateCompanyData} = this.props;

        if(!selectedCompany) return false;

        const formData = new FormData();

        for (const key in this.refs){
            formData.append(key, this.refs[key].value)
        }

        updateCompanyData(
            selectedCompany.id,
            formData,
            (data) => {
                this.onEdit('save');

                Alert.success('Изменения сохранены', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
        );
    }

    render() {

        const {
            selectedCompany,
            company:{companies},
            handleCompany,
            handleSelectedCompany,
            employees:{admins},
        } = this.props;


        if(!companies.data.results.length) {
            return <CreateCompanyMessage />
        }

        let options = [];
        companies.data.results.map((item, index) =>
            options.push({
                value: item.id,
                label: item.title,
            })
        );

        if(!selectedCompany){
            return false;
        }

	    return(
            <div className="menu-content-company-data menu-content-item tab-parent screen-bottom-block">

                <Alert stack={{limit: 1}} />

                <div className="rounded-white-block">
                    <div ref="form" className="white-block-content">
                        <ul className="data-with-labels">
                            <li>
                                <label>Выберите компанию</label>
                                <Select
                                    name="company-list"
                                    noResultsText="Список пуст"
                                    value={selectedCompany.id}
                                    onChange={(company) => handleCompany(company)}
                                    clearable={false}
                                    options={options}
                                />
                            </li>
                            <li>
                                <label>Полное название</label>
                                <input
                                    ref="full_title"
                                    name="full_title"
                                    type="text"
                                    className="value"
                                    disabled
                                    value={selectedCompany.full_title}
                                    onChange={(e) => handleSelectedCompany(e)}
                                    placeholder="Полное название компании"
                                />                                
                            </li>
                            <li>
                                <label>Краткое название</label>
                                <input
                                    ref="title"
                                    name="title"
                                    type="text"
                                    className="value"
                                    disabled
                                    value={selectedCompany.title}
                                    onChange={(e) => handleSelectedCompany(e)}
                                    placeholder="Краткое название компании"
                                />
                            </li>
                            <li>
                                <label>Юридчиеский адрес</label>
                                <input
                                    ref="ur_address"
                                    name="ur_address"
                                    type="text"
                                    className="value"
                                    disabled
                                    value={selectedCompany.ur_address}
                                    onChange={(e) => handleSelectedCompany(e)}
                                    placeholder="Юридчиеский адрес"
                                />
                            </li>
                        </ul>

                        <div className="semiheader semiheader-left">
                            <h3>
                                Администратор юридического лица
                            </h3>
                        </div>

                        {
                            admins.isFetching
                            ?
                            <ul className="data-with-labels">
                                <li>
                                    <label>Загружается...</label>
                                </li>
                            </ul>
                            :
                            admins.results.length
                            ?
                            <ul className="data-with-labels">
                                <li>
                                    <label>Имя и фамилия</label>
                                </li>
                                {
                                    admins.results.map((item, index) =>
                                        <li key={index}>
                                            <strong className="value">
                                                {`${item.user.first_name} ${item.user.last_name}`}
                                            </strong>
                                        </li>
                                    )
                                }
                            </ul>
                            :
                            <ul className="data-with-labels">
                                <li>
                                    <label>Не установлен</label>
                                </li>
                            </ul>
                        }

                        {
                            selectedCompany.is_admin ?
                            <div className="actions">
                                <div className="big-button empty-button">
                                    <button onClick={() => this.onEdit()}>
                                        {this.state.formEdit ? 'Отмена' : 'Редактировать'}
                                    </button>
                                </div>
                                {
                                    this.state.formEdit
                                    ?
                                    <div className="big-button">
                                        <button onClick={this.onSubmit.bind(this)}>Сохранить</button>
                                    </div>
                                    : null
                                }
                            </div>
                            : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps, {updateCompanyData})(CompanyData);


// WEBPACK FOOTER //
// ./src/components/AccountLaw/CompanyData.js